export default __webpack_public_path__ + "static/media/portrait-square-08.8f02d9f7.jpeg";